const { useState, useCallback } = require('react');
/**
 * Useful for setting, unsetting and toggle boolean values with less boilerplate code. Example; show/hide dialogs
 * @param initialValue Default false
 * @returns {[boolean, (function(): void), (function(): void), (function(): void)]}
 */
const useBoolean = (initialValue = false) => {
  const [state, setState] = useState(initialValue);
  const toggle = useCallback(() => setState(oldState => !oldState), []);
  const setTrue = useCallback(() => setState(true), []);
  const setFalse = useCallback(() => setState(false), []);

  return [state, setTrue, setFalse, toggle];
};

export default useBoolean;
